import { MaskedLine } from "@/components/Reveal";

export default function PageHeader({ overline, title, sub }) {
  return (
    <div className="border-b border-wire bg-obsidian noise-overlay pt-32 pb-14 sm:pt-40 sm:pb-20" data-testid="page-header">
      <div className="mx-auto max-w-[1600px] px-5 sm:px-8">
        <p className="font-mono text-[10px] tracking-[0.35em] text-neutral-500">{overline}</p>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight text-white">
          <MaskedLine>{title}</MaskedLine>
        </h1>
        {sub && <p className="mt-6 max-w-xl font-mono text-xs leading-relaxed tracking-wider text-neutral-400">{sub}</p>}
      </div>
    </div>
  );
}
